import { Token } from '../../../../api/DynaVaultsAPI';
import { CHAINS } from '@dapp/multi-lib/network';
import { TOKENS } from 'utils/constants/tokens';
import {
  NATIVE_BNB_TOKEN,
  NATIVE_ETH_TOKEN,
} from 'structure/pv2/vault/utils/nativeDeposit';

interface DepositToken extends Token {
  available: boolean;
}

interface DepositTokenList {
  [chainId: number]: DepositToken[];
}

export const depositTokenList = {
  [CHAINS.OPTIMISM_MAINNET]: [
    {
      ...TOKENS.OPTIMISM.WETH,
      available: true,
    },
    {
      ...TOKENS.OPTIMISM.WBTC,
      available: true,
    },
  ],
  [CHAINS.ARBITRUM_ONE]: [
    {
      ...NATIVE_ETH_TOKEN,
      available: true,
    },
    {
      ...TOKENS.ARBITRUM.USDC,
      available: true,
    },
    {
      ...TOKENS.ARBITRUM.USDT,
      available: true,
    },
    {
      ...TOKENS.ARBITRUM.WETH,
      available: true,
    },
    {
      ...TOKENS.ARBITRUM.WBTC,
      available: true,
    },
  ],
  [CHAINS.POLYGON_MAINNET]: [
    {
      ...TOKENS.POLYGON.WPOL,
      available: true,
    },
    {
      ...TOKENS.POLYGON.WETH,
      available: true,
    },
    {
      ...TOKENS.POLYGON.WBTC,
      available: true,
    },
  ],
  [CHAINS.BSC_MAINNET]: [
    {
      ...NATIVE_BNB_TOKEN,
      available: true,
    },
    {
      ...TOKENS.BNB.USDC,
      available: true,
    },
    {
      ...TOKENS.BNB.USDT,
      available: true,
    },
    {
      ...TOKENS.BNB.WBNB,
      available: true,
    },
    {
      ...TOKENS.BNB.BTCB,
      available: true,
    },
    {
      ...TOKENS.BNB.XAUt,
      available: true,
    },
  ],
  [CHAINS.ETH_FORKED]: [
    {
      symbol: 'USDC',
      name: 'USDC',
      address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      decimals: 6,
      available: true,
    },
    {
      symbol: 'SDAO',
      name: 'SDAO',
      address: '0x993864E43Caa7F7F12953AD6fEb1d1Ca635B875F',
      decimals: 18,
      available: true,
    },
    {
      symbol: 'WETH',
      name: 'WETH',
      address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      decimals: 18,
      available: process.env.NEXT_PUBLIC_NODE_ENV === 'development',
    },
  ],
  [CHAINS.BASE_L2]: [
    {
      ...NATIVE_ETH_TOKEN,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.USDC,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.USDT,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.WETH,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.cbBTC,
      available: true,
    },
    {
      ...TOKENS.BASE_L2.EURC,
      available: true,
    },
  ],
  [CHAINS.ETH_MAINNET]: [
    {
      ...NATIVE_ETH_TOKEN,
      available: true,
    },
    {
      symbol: 'USDC',
      name: 'USDC',
      address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
      decimals: 6,
      available: true,
    },
    {
      symbol: 'USDT',
      name: 'USDT',
      address: '0xdac17f958d2ee523a2206206994597c13d831ec7',
      decimals: 6,
      available: true,
    },
    {
      ...TOKENS.ETHEREUM.WETH,
      available: true,
    },
    {
      ...TOKENS.ETHEREUM.WBTC,
      available: true,
    },
  ],
} as const satisfies DepositTokenList;

export const getDepositTokenList = (chainId: number): DepositToken[] => {
  const listOfTokens: DepositToken[] =
    (depositTokenList as DepositTokenList)[chainId] || [];
  return listOfTokens.filter((item) => item.available);
};

export const getDepositTokenByAddress = (
  chainId: number,
  tokenAddress?: string
): DepositToken | undefined => {
  if (!tokenAddress) return undefined;

  const tokenList: DepositToken[] =
    (depositTokenList as DepositTokenList)[chainId] || [];

  return tokenList.find(
    (token) => token.address.toLowerCase() === tokenAddress.toLowerCase()
  );
};

export const getDefaultDepositToken = (
  chainId: number,
  vaultDepositToken?: `0x${string}`
): DepositToken | undefined => {
  const tokenList = getDepositTokenList(chainId);
  if (!vaultDepositToken) return tokenList[0];

  return (
    tokenList.find(
      (token) => token.address.toLowerCase() === vaultDepositToken.toLowerCase()
    ) ?? tokenList[0]
  );
};
